const slugifyString = (str: string | null, separator = '-'): string => {
  if (typeof str === 'string') {
    return str
      .toLowerCase()
      .replace(/[^\w ]+/g, '')
      .replace(/ +/g, separator);
  }
  return '';
};

export default slugifyString;
